import { ContextMenuSelect, DataGrid } from '@turnpike/portal-data-grid';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useDeleteOrganizationMutation, useSystemStatusInfiniteQuery } from '../../api';

import { useTableLayoutColumns } from './TableLayout.columns';
import Styles from './TableLayout.module.scss';

import type { SystemStatusModel } from '../../model/types/system-status.model';

import { useAppSelector } from '@/app/hooks/useAppSelector';
import { EditIcon, DeleteIcon } from '@/components/Elements/Icons';
import { DeleteModal } from '@/components/Modals/DeleteModal';

export const TableLayout = () => {
	const navigate = useNavigate();
	const [deletedOrganization, setDeletedOrganization] = useState<SystemStatusModel | undefined>(
		undefined
	);
	const [searchParams] = useSearchParams();
	const search = searchParams.get('filter') ?? '';
	const filter = useAppSelector((state) => state.filter);
	const [deleteOrganization, organizationMutation] = useDeleteOrganizationMutation();
	const { currentData, isLoading, isFetching } = useSystemStatusInfiniteQuery({
		...filter,
		title: search,
		organizationName: search,
	});
	const isLoadingData = isLoading || (!currentData && isFetching);

	const handleEdit = (item: SystemStatusModel) => {
		navigate(`/organizations/${item.organizationId}`);
	};

	const handleDelete = (item: SystemStatusModel) => {
		setDeletedOrganization(item);
	};

	const items = currentData?.pages?.flatMap((page) => page.items) ?? [];
	const { columns } = useTableLayoutColumns();

	return (
		<div className={Styles.container}>
			<div className={Styles.gridContainer}>
				<DataGrid
					isLoading={isLoadingData}
					data={items}
					columns={columns}
					renderActions={(item: SystemStatusModel) => {
						return (
							<ContextMenuSelect>
								<ContextMenuSelect.Option
									title="Edit"
									icon={<EditIcon />}
									onClick={() => handleEdit(item)}
								/>
								<ContextMenuSelect.Option
									title="Delete"
									icon={<DeleteIcon />}
									onClick={() => handleDelete(item)}
								/>
							</ContextMenuSelect>
						);
					}}
				/>
			</div>
			{deletedOrganization && (
				<DeleteModal
					isLoading={organizationMutation.isLoading}
					preventClose={organizationMutation.isLoading}
					title="Are you sure you wish to delete?"
					onCloseRequest={() => {
						setDeletedOrganization(undefined);
					}}
					onClick={async () => {
						if (deletedOrganization) {
							await deleteOrganization(deletedOrganization.organizationId);
						}
					}}
				>
					<span>{deletedOrganization?.name}</span>
				</DeleteModal>
			)}
		</div>
	);
};
